import React from 'react';
import NavbarBase from '@material-ui/core/BottomNavigation';

const Navbar = ({ children, ...props }) => (
  <NavbarBase {...props}>{children}</NavbarBase>
);

export default Navbar;
